
import { defineComponent, onMounted } from 'vue';
import { useStore } from 'vuex';
import router from '@/router';
import { useRoute } from 'vue-router';

export default defineComponent({
    name: 'Redeem',
    setup() {
        const store = useStore();
        const route = useRoute();

        onMounted(async () => {
            const urlQuery = route.query;
            const token = urlQuery?.tokenKey;

            if (!token) {
                router.push({ name: 'maps' });
            }

            try {
                await store.dispatch('auth/redeem', token);
            } catch (error) {
                new Error(error);
            }

            router.replace({ name: 'maps' });
        });
    },
});
